/**
 * Created by Bowen on 5/24/2020.
 * Description:
 * Add contact body component
 *
 * ------ maintenance history ------
 */
import { Component, OnInit, ChangeDetectorRef, Input, ViewChild, OnDestroy } from '@angular/core';
import { businessConstants } from '../../../../constants/business.constants';
import { ContextMenuConfig } from '../../../../widgets/tam-context-menu/tam-context-menu.model';
import { ContextMenuService, ContextMenuComponent } from '@perfectmemory/ngx-contextmenu';
import { ContactDetailService } from '../../contact-body-detail.service';
import { ContactComponentActionTypes, ContactComponentCategory, ContactBasicInformationCategory, RelationshipTreeShowAs } from '../../contact-body-detail.model';
import { fromEvent, Subscription, of, forkJoin, Observable } from 'rxjs';
import { EntityType } from '../../../../tamalelibs/models/entity-type.model';
import { Router } from '@angular/router';
import { SystemUser } from '../../../../tamalelibs/models/user.model';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { select, Store } from '@ngrx/store';
import { validRelationshipTypeSelector } from '../../../../redux/reducers/valid-relationship-type.reducer';
import { AppState } from '../../../../redux';
import { ValidRelationshipType } from '../../../../tamalelibs/models/valid-relationship-type.model';
import * as _lodash from 'lodash';
import { EntityDialogOpenOptions, EntityDialogType } from '../../../entity-dialog/entity-dialog.model';
import { take, map, catchError } from 'rxjs/operators';
import { DialogAction } from '../../../../widgets/tam-dialog/tam-dialog.model';
import { RelationshipTreeActions, RelationshipTreeEvents, RelationshipTreeNode, RelationshipTreeNodeCategory } from '../../../relationship-tree/relationship-tree.view-model';
import { ContactTemplateOpenOptions, ContactTemplateType } from '../../../contact-dialog-new/contact-dialog.model';
import { Contact } from '../../../../tamalelibs/models/contact.model';
import { EntityDialogService } from '../../../entity-dialog/entity-dialog.service';
import { ContactService } from '../../../../tamalelibs/services/contact.service';
import { RemoveRelationshipDialogService } from '../../../relationship-tree/remove-relationship-dialog/remove-relationship-dialog.service';
import { AddRelationshipEntityDialogService } from '../../../relationship-tree/add-relationship-entity-dialog/add-relationship-entity-dialog.service';
import { OpenDynamicComponentService } from '../../../../pages/home/home-open-dynamic-component';
import { RelationshipTreeService } from '../../../../services/relationship-tree.service';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { NoteDialogOpenOptions, NoteDialogType } from '../../../note-dialog/note-dialog.model';
import { EntityBrief } from '../../../../tamalelibs/models/entity-brief.model';
import { NoteDialogService } from '../../../note-dialog/note-dialog.service';
import { RelationshipType } from '../../../../tamalelibs/models/relationship-type.model';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { RelationshipService } from '../../../../tamalelibs/services/relationship.service';
import { RelationshipTypeActionTypes } from '../../../../redux/actions/relationship-type.actions';
import { SlideSheetService } from '../../../../services/slide-sheet.service';
import { SlideSheetActionTypes, SlideSheetEventTypes } from '../../../slide-sheet/slide-sheet.model';

@Component({
    selector: 'tam-contact-relationship',
    templateUrl: './contact-relationship.component.html',
    styleUrls: ['./contact-relationship.component.scss']
})
export class ContactRelationshipComponent implements OnInit, OnDestroy {
    @Input() config;
    @ViewChild('meatballContextItemMenu', { static: false }) meatballContextItemMenu: ContextMenuComponent<any>;
    @ViewChild('contextItemMenu', { static: false }) itemMenuEle: ContextMenuComponent<any>;
    @ViewChild('relationshipTypeContextMenu', { static: false }) relationshipTypeMenuEle: ContextMenuComponent<any>;
    @ViewChild('relationshipPanelContextMenu', { static: false }) relationshipPanelMenuEle: ContextMenuComponent<any>;
    menuItems = ['All', 'Entities', 'Contacts', 'Teams', 'Employment'];
    selectedIndex = 0;
    defaultRelationshipItems = []; // all the relationships set
    relationshipItems = []; // for different tab, will get related relationships
    contextMenuConfig: ContextMenuConfig;
    noDataStyle = 'none';
    isCollapse = false;
    windowSize: number;
    rootNode: RelationshipTreeNode = null;

    // below var is for context menu
    contextMenu: Array<any>;
    totalValidRelationshipType: Array<ValidRelationshipType>;
    showAsShortNameChecked = true; // showAsname checked
    showAsNameChecked = false; // showAsname checked

    // below var is for context menu condition
    isEditDetailsShow = false;
    isChangeTypeMenuShow = false;
    isRemoveRelationshipMenuShow = false;
    isAddEntityMenuShow = false;
    isAddContactMenuShow = false;
    isEditTeamMemberMenuShow = false;
    isRemoveAllRelationshipMenuShow = false;

    // below var is for relationship context menu action
    currentClickedItemNode = null;
    showNameForRemoveDialog = null;
    childForCurrentClickedParentNodes = null;
    selectedItemValidRelationshipType = [];

    private _destroySubscriptions: Array<Subscription> = [];
    private _currentUser: SystemUser;

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _contextMenuService: ContextMenuService<any>,
        private _contactDetailService: ContactDetailService,
        private _router: Router,
        private _store: Store<AppState>,
        private _storeQuerierService: StoreQuerierService,
        private _entityDialogService: EntityDialogService,
        private _contactService: ContactService,
        private _removeRelationshipDialogService: RemoveRelationshipDialogService,
        private _addRelEntityDialogService: AddRelationshipEntityDialogService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _relationshipTreeService: RelationshipTreeService,
        private _contactTemplateService: ContactTemplateService,
        private _noteDialogService: NoteDialogService,
        private _toast: ToastService,
        private _relationshipService: RelationshipService,
        private _slideSheetService: SlideSheetService,
    ) {
        this._currentUser = this._storeQuerierService.getCurrentUser();
    }

    ngOnInit() {
        this._initContextMenu();
        // will control if it will collapse: 1 will collapse, 0 will not collapse
        if (this.config && this.config.isCollapsed === '1') {
            this.isCollapse = true;
        }
        // will control if show as name or shortName
        if (this.config.showAs === 'name') {
            this.showAsShortNameChecked = false;
            this.showAsNameChecked = true;
        } else {
            this.showAsShortNameChecked = true;
            this.showAsNameChecked = false;
        }
        this._initData(this.config.data);
        this.windowSize = window.innerWidth;
        this._destroySubscriptions.push(
            fromEvent(window, 'resize').subscribe((e: any) => {
                this.isCollapse = false;
                this.windowSize = e.target.innerWidth;
                this._updateChangesToUI();
            }),
            this._contactDetailService.action$.subscribe(res => {
                this._actionMessageHandler(res);
            }),
            this._store.pipe(
                select(validRelationshipTypeSelector)
            ).subscribe(data => this.totalValidRelationshipType = data),
            // Listening the change of the contact
            this._slideSheetService.slideSheetFeedbackSubject$.subscribe(res => {
                // Update contact note information
                if (res.type === SlideSheetEventTypes.CONTACT_VALUE_CHANGE) {
                    this._initData(this.config.data);
                    this._setRelationshipStyleByData();
                    this._updateChangesToUI();
                }
            })
        );
        this._updateChangesToUI();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // will watch the meatball click
    onMeatball(event: MouseEvent, item: any) {
        this._changeDetectorRef.detectChanges();
        this._contextMenuService.show(this.meatballContextItemMenu, { x: event.clientX, y: event.clientY });
        event.preventDefault();
        event.stopPropagation();
    }

    // will watch the menu select after clicking the meatball
    onMenuSelect(event) {
        const type = event.event.target.innerText;
        if (type === ContactComponentActionTypes.COLLAPSE_TILE) {
            this.isCollapse = true;
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.COLLAPSE_TILE,
                payload: {
                    origin: ContactComponentCategory.ContactRelationships,
                    originPosition: this.config.position,
                    seletedTab: this.selectedIndex
                }
            });
        } else if (type === ContactComponentActionTypes.EXPAND_TILE) {
            this.isCollapse = false;
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.EXPAND_TILE,
                payload: {
                    origin: ContactComponentCategory.ContactRelationships,
                    originPosition: this.config.position,
                    seletedTab: this.selectedIndex
                }
            });
        } else {
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.CHANGE_COMPONENT,
                payload: {
                    origin: ContactComponentCategory.ContactRelationships,
                    target: type,
                    originPosition: this.config.position
                }
            });
        }
    }

    onItemClick($event, item) {
        if (item.clickable && item.nodeDetail && item.nodeDetail.type.id === EntityType.CONTACT.id) {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.CONTACT_PANEL,
                payload: item.valueId
            });
        } else {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.ENTITY_PANEL,
                payload: item.valueId
            });
        }
    }

    onRelationshipMenuSelect(event) {
        if (event) {
            const type = event.event.target.innerText; // context menu type id
            const item = this.currentClickedItemNode;

            switch (type) {
                case 'View Details':
                    if (item.type.id === EntityType.CONTACT.id) {
                        this._router.navigate(['contact', item.id]);
                    } else {
                        this._router.navigate(['entity', item.id]);
                    }
                    break;
                case 'Edit Details':
                    this._openEditDetailDialog(item);
                    break;
                case 'New Note':
                    this._openNoteDialog(item);
                    break;
                case 'Edit Team Members':
                    this._openEditTeamMemberDialog(this.rootNode);
                    break;
                case 'Remove Relationship':
                    this._openRemoveItemRelationshipDialog(item);
                    break;
                case 'Add Entity':
                    this._openAddEntityDialog(RelationshipTreeActions.ADD_ENTITIES, item);
                    break;
                case 'Add Contact':
                    this._openAddEntityDialog(RelationshipTreeActions.ADD_CONTACTS, item);
                    break;
                case 'Show as Shortname':
                    this._triggerShowAsChange('shortName');
                    break;
                case 'Show as Name':
                    this._triggerShowAsChange('name');
                    break;
                case 'Remove All of This Type':
                    this._openRemoveParentRelationshipDialog(item);
                    break;
                default:
                    break;
            }
            this._changeDetectorRef.detectChanges();
        }
    }

    mouseRightClickOnPanel(event) {
        if (this._currentUser.credential.editRelationshipTree) {
            // only all, entity tab will show the add entity menu
            if (this.selectedIndex === 0 || this.selectedIndex === 1) {
                this.isAddEntityMenuShow = true;
            } else {
                this.isAddEntityMenuShow = false;
            }
            if (this.selectedIndex === 0 || this.selectedIndex === 2) {
                this.isAddContactMenuShow = true;
            } else {
                this.isAddContactMenuShow = false;
            }
        } else {
            this.isAddEntityMenuShow = false;
            this.isAddContactMenuShow = false;
        }
        if (this.rootNode.type.id === EntityType.TEAM.id && this._currentUser.credential.manageTeam) {
            this.isEditTeamMemberMenuShow = true;
        } else {
            this.isEditTeamMemberMenuShow = false;
        }
        this._changeDetectorRef.detectChanges();
        this._contextMenuService.show(this.relationshipPanelMenuEle, { x: event.clientX, y: event.clientY });
        event.preventDefault();
        event.stopPropagation();
    }

    mouseRightClick(event, clickedItem) {
        const item = clickedItem.nodeDetail;
        if (item && item.nodeType === RelationshipTreeNodeCategory.ENTITY) {
            // add conditional for relationship team edit.
            if (!this._currentUser.credential.manageTeam && item && item.type && item.type.id === EntityType.TEAM.id) {
                this.isEditDetailsShow = false;
            } else {
                this.isEditDetailsShow = true;
            }
        }
        // if have the edit relationship crediential, user will be able to remove, add contact/entity, should not affect edit team member
        // ppc user will be able to edit team member
        this.isChangeTypeMenuShow = false;
        this.isRemoveRelationshipMenuShow = false;
        this.isAddEntityMenuShow = false;
        this.isEditTeamMemberMenuShow = false;
        this.currentClickedItemNode = clickedItem.nodeDetail;
        const selfRelationshipArray: Array<any> = [];
        const entityCondition = item && item.parentId !== RelationshipTreeNodeCategory.TEAMS_GROUP && item.parentId !== RelationshipTreeNodeCategory.TEAM_MEMBER_GROUP;
        const currentEmploymentControl = item.parentId && (!(item.parentId.includes(RelationshipTreeNodeCategory.FORMER_EMPLOYMENT_GROUP)
            || item.parentId.includes(RelationshipTreeNodeCategory.CURRENT_EMPLOYMENT_GROUP)));

        // this function is for add contact
        // contact cannot add contact, entity and teams can add contact
        // entity can add contact and entity
        // teams can add contact and entity
        if (this._currentUser.credential.editRelationshipTree && (this.selectedIndex === 0 || this.selectedIndex === 2)) {
            this.isAddContactMenuShow = true;
        } else {
            this.isAddContactMenuShow = false;
        }

        // this condition is for add entity and remove relationship
        // to make sure if the remove function needs to show in menu
        if (entityCondition && this._currentUser.credential.editRelationshipTree) {
            if (this.selectedIndex === 0 || this.selectedIndex === 1) {
                this.isAddEntityMenuShow = true;
            } else {
                this.isAddEntityMenuShow = false;
            }
            if (currentEmploymentControl) {
                this.isRemoveRelationshipMenuShow = true;
            } else {
                this.isRemoveRelationshipMenuShow = false;
            }
        } else {
            this.isRemoveRelationshipMenuShow = false;
            this.isAddEntityMenuShow = false;
        }

        // get self relationship type array
        if (item.level !== '1') {
            this.config.data.forEach(element => {
                if (item.id === element.id) {
                    selfRelationshipArray.push(element.parentId.slice(-32));
                }
            });
        }

        // for relationship type and team member group and teams group
        if (item.level === '3') {
            // edit team member
            if (this.rootNode.type.id === EntityType.TEAM.id && item.parentId === RelationshipTreeNodeCategory.TEAM_MEMBER_GROUP &&
                this._currentUser.credential.manageTeam) {
                this.isEditTeamMemberMenuShow = true;
            } else {
                this.isEditTeamMemberMenuShow = false;
            }

            // control remove relationship show
            if (currentEmploymentControl) {
                this.isRemoveAllRelationshipMenuShow = true;
            } else {
                this.isRemoveAllRelationshipMenuShow = false;
            }

            // only contact relationship type can add contact
            if (entityCondition && this._currentUser.credential.editRelationshipTree) {
                if (this.selectedIndex === 0 || this.selectedIndex === 1) {
                    this.isAddEntityMenuShow = true;
                } else {
                    this.isAddEntityMenuShow = false;
                }
                this._changeDetectorRef.detectChanges();
                this._contextMenuService.show(this.relationshipTypeMenuEle, { x: event.clientX, y: event.clientY });
            } else {
                this.isAddEntityMenuShow = false;
                this._changeDetectorRef.detectChanges();
                this._contextMenuService.show(this.itemMenuEle, { x: event.clientX, y: event.clientY });
            }
        }

        // for entity and contact node
        if (item.id && item.level === '4') {
            if (this._currentUser.credential.editRelationshipTree) {
                this.selectedItemValidRelationshipType.splice(0, this.selectedItemValidRelationshipType.length);
                this.totalValidRelationshipType.forEach(element => {
                    // common condition
                    const commonCondition = element.childEntityType.id === item.type.id &&
                        element.parentEntityType.id === this.rootNode.type.id;
                    // contact all condition
                    const contactAllCondition = element.childEntityType.id === EntityType.CONTACT.id &&
                        element.parentEntityType.id === EntityType.CONTACT.id;
                    // teams condition
                    const selfCondition = selfRelationshipArray && selfRelationshipArray.includes(element.relationshipType.id);

                    // to make sure if the remove function needs to show in menu
                    if (entityCondition) {
                        if (currentEmploymentControl) {
                            this.isRemoveRelationshipMenuShow = true;
                        } else {
                            this.isRemoveRelationshipMenuShow = false;
                        }
                        // only in all tab, entity tab can show the add entity function
                        if (this.selectedIndex === 0 || this.selectedIndex === 1) {
                            this.isAddEntityMenuShow = true;
                        } else {
                            this.isAddEntityMenuShow = false;
                        }
                    } else {
                        this.isRemoveRelationshipMenuShow = false;
                        this.isAddEntityMenuShow = false;
                    }

                    // get the selectedItemValidRelationshipType for change type function
                    if (this.rootNode.type.id === EntityType.CONTACT.id) {
                        if (item.type.id === EntityType.CONTACT.id && !selfCondition) {
                            // parent: contact child: entity
                            if (element.childEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id &&
                                element.parentEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id) {
                                this.selectedItemValidRelationshipType.push({
                                    'id': element.relationshipType.id,
                                    'caption': element.relationshipType.name,
                                    'items': null
                                });
                            }
                        } else {
                            // parent: contact child: contact
                            if ((commonCondition || contactAllCondition) && entityCondition && !selfCondition &&
                                element.childEntityType.id !== EntityType.CONTACTSFORVALIDRELTYPE.id &&
                                element.parentEntityType.id !== EntityType.CONTACTSFORVALIDRELTYPE.id) {
                                this.selectedItemValidRelationshipType.push({
                                    'id': element.relationshipType.id,
                                    'caption': element.relationshipType.name,
                                    'items': null
                                });
                            }
                        }
                    } else {
                        if ((item.type.id === EntityType.CONTACT.id) &&
                            (commonCondition || contactAllCondition) && entityCondition && !selfCondition) {
                            // parent: entity child: contact
                            this.selectedItemValidRelationshipType.push({
                                'id': element.relationshipType.id,
                                'caption': element.relationshipType.name,
                                'items': null
                            });
                        } else if (commonCondition && !selfCondition) {
                            // parent: entity child: entity
                            this.selectedItemValidRelationshipType.push({
                                'id': element.relationshipType.id,
                                'caption': element.relationshipType.name,
                                'items': null
                            });
                        }
                    }
                });
                if (this.selectedItemValidRelationshipType.length !== 0 && currentEmploymentControl) {
                    this.isChangeTypeMenuShow = true;
                    this.selectedItemValidRelationshipType = _lodash.uniqWith(
                        this.selectedItemValidRelationshipType, _lodash.isEqual);

                    this.selectedItemValidRelationshipType = _lodash.sortBy(
                        this.selectedItemValidRelationshipType, element => element.caption);
                }
            }
            this._changeDetectorRef.detectChanges();
            this._contextMenuService.show(this.itemMenuEle, { x: event.clientX, y: event.clientY });
        }
        event.preventDefault();
        event.stopPropagation();
    }

    changeRelationshipType(event, item) {
        const eventItem = this.currentClickedItemNode;
        const createRelationshipObj = {};
        createRelationshipObj['appendRelationship'] = true;
        createRelationshipObj['relTypeId'] = item.id;
        createRelationshipObj['currentControlValues'] = [eventItem.id];
        createRelationshipObj['dependenceControlValues'] = [this.rootNode.id];

        this._relationshipService.createRelationship(createRelationshipObj).pipe(
            catchError((err) => {
                this._toastMessageHandler('Relationship updated failed.', NotificationStyles.Error);
                this._store.dispatch({
                    type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP
                });
                return of(null);
            }),
            take(1)
        ).subscribe((res) => {
            if (res) {
                this._relationshipService.deleteRelationship(eventItem.relationshipId, true).pipe(
                    catchError((err) => {
                        if (err.message && err.message.indexOf('404') > -1 && err.message.indexOf('ERR_NOT_FOUND') > -1) {
                            this._store.dispatch({
                                type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP
                            });
                            return of('ERR_NOT_FOUND');
                        } else {
                            this._relationshipService.deleteRelationship(res.id, true);
                            this._toastMessageHandler('Relationship updated failed.', NotificationStyles.Error);
                            return of('ERROR');
                        }
                    }),
                    take(1)
                ).subscribe((response) => {
                    this._changeDetectorRef.detectChanges();
                    if (response !== 'ERROR') {
                        // need to seperate, or all the screens will refresh
                        this._relationshipTreeService.relationshipTreeOperate$.next({
                            type: RelationshipTreeActions.CHANGE_RELATIONSHIP,
                            payload: {
                                rootNodeId: this.rootNode.id,
                                clickedItem: eventItem,
                                targetRelationshipType: item
                            }
                        });
                        this._toastMessageHandler('Relationship successfully updated.', NotificationStyles.Success);
                    }
                });
            }
        });
    }

    // get the relationships for current Index page: All, Entities, Contacts, Employment
    selectChange(currentTabIndex: number) {
        this.selectedIndex = currentTabIndex;
        this.relationshipItems = [];
        if (this.selectedIndex === 0) {
            this.relationshipItems = this.defaultRelationshipItems;
        } else if (this.selectedIndex === 1) {
            // tslint:disable-next-line: max-line-length
            this.relationshipItems = this.defaultRelationshipItems.filter(item => item.value[0].nodeDetail.parentId.indexOf(RelationshipTreeNodeCategory.ENTITY_GROUP) > -1);
        } else if (this.selectedIndex === 2) {
            // tslint:disable-next-line: max-line-length
            this.relationshipItems = this.defaultRelationshipItems.filter(item => item.value[0].nodeDetail.parentId.indexOf(RelationshipTreeNodeCategory.CONTACTS_GROUP) > -1);
        } else if (this.selectedIndex === 3) {
            // tslint:disable-next-line: max-line-length
            this.relationshipItems = this.defaultRelationshipItems.filter(item => item.value[0].nodeDetail.parentId.indexOf(RelationshipTreeNodeCategory.TEAMS_GROUP) > -1);
        } else if (this.selectedIndex === 4) {
            const currentRelationshipItems = this.defaultRelationshipItems.filter(item => item.value[0].nodeDetail.parentId.indexOf(RelationshipTreeNodeCategory.CURRENT_EMPLOYMENT_GROUP) > -1);
            const formerRelationshipItems = this.defaultRelationshipItems.filter(item => item.value[0].nodeDetail.parentId.indexOf(RelationshipTreeNodeCategory.FORMER_EMPLOYMENT_GROUP) > -1);
            if (currentRelationshipItems.length > 0 && formerRelationshipItems.length > 0) {
                this.relationshipItems = currentRelationshipItems.concat([{ title: 'item-divider' }]).concat(formerRelationshipItems);
            } else if (currentRelationshipItems.length > 0 && formerRelationshipItems.length === 0) {
                this.relationshipItems = currentRelationshipItems;
            } else if (currentRelationshipItems.length === 0 && formerRelationshipItems.length > 0) {
                this.relationshipItems = formerRelationshipItems;
            } else {
                this.relationshipItems = [];
            }
        }
        this._setRelationshipStyleByData();
        this._contactDetailService.action$.next({
            type: ContactComponentActionTypes.CHANGE_TAB,
            payload: {
                origin: ContactComponentCategory.ContactRelationships,
                originPosition: this.config.position,
                seletedTab: this.selectedIndex,
                showAs: this.showAsNameChecked ? RelationshipTreeShowAs.Name : RelationshipTreeShowAs.ShortName,
            }
        });
        this._updateChangesToUI();
    }

    trackByFn(index, item) {
        return item.id;
    }

    private _openEditDetailDialog(item) {
        if (item.type.id === EntityType.CONTACT.id) {
            this._openContactDialog(item.id);
        } else {
            // add 'edit entity'
            const entityDialogOpenOptions = new EntityDialogOpenOptions();
            entityDialogOpenOptions.openType = EntityDialogType.EditEntity;
            entityDialogOpenOptions.entityId = item.id;
            this._entityDialogService.dialogOpen$.next(entityDialogOpenOptions);
        }
        this._openDynamicComponentService.feedbackSubject$.pipe(
            take(1)
        ).subscribe(res => {
            if (res.type === DialogAction.CloseDialog && res.payload) {
                this._relationshipTreeService.relationshipTreeOperate$.next({
                    type: RelationshipTreeActions.EDIT_DETAILS,
                    payload: {
                        itemId: item.id,
                    }
                });
            }
        });
    }

    // open contact dialog
    private _openContactDialog(id) {
        this._contactService.getContactDetail(id).pipe(
            take(1),
            map(response => {
                return Contact.parse(response, true);
            })).subscribe(response => {
                const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
                _contactDialogOpenOptions.openType = ContactTemplateType.EditContact;
                _contactDialogOpenOptions.contact = response;
                this._contactTemplateService.dialogOpen$.next(_contactDialogOpenOptions);
            });
    }

    private _openNoteDialog(item) {
        const entity: EntityBrief = {
            id: item.id,
            name: item.name,
            shortName: item.shortName,
            type: item.type,
            isPublic: item.isPublic,
            company: item.company,
        };
        const noteParam: NoteDialogOpenOptions = {
            openType: NoteDialogType.CreateNote,
            isPlugInEditNoteMode: false,
            entity: entity,
            minimizable: false,
            entryId: '',
            entityFieldEditable: false,
        };
        this._noteDialogService.dialogOpen$.next(noteParam);
    }

    private _openEditTeamMemberDialog(item) {
        const entityDialogOpenOptions = new EntityDialogOpenOptions();
        entityDialogOpenOptions.openType = EntityDialogType.EditEntity;
        entityDialogOpenOptions.entityId = item.id;
        entityDialogOpenOptions.openTab = 1;
        this._entityDialogService.dialogOpen$.next(entityDialogOpenOptions);
    }

    private _openRemoveItemRelationshipDialog(item) {
        this.currentClickedItemNode = item;
        // 1: get rootNode information
        let isRootNodeForEntity = true;
        if (this.rootNode.type.id === EntityType.CONTACT.id) {
            isRootNodeForEntity = false;
        }

        // 2: get relationship type information
        let relationshipTypeName = '';
        for (let i = 0; i < this.config.data.indexOf(item); i++) {
            if (item.parentId === this.config.data[i].uuid) {
                relationshipTypeName = this.config.data[i].name;
            }
        }

        // 3: get clicked item name: need to judge according to showAsName
        if (this.showAsShortNameChecked) {
            this.showNameForRemoveDialog = item.shortName;
        } else {
            this.showNameForRemoveDialog = item.name;
        }

        // 4: get the var: isContactParent
        let isContactParent = false;
        if (item.type.id === EntityType.CONTACT.id) {
            isContactParent = true;
        }

        // 5: send the data to subject
        this._removeRelationshipDialogService.open(
            // tslint:disable-next-line: max-line-length
            this.rootNode, this.rootNode.shortName, relationshipTypeName, this.showNameForRemoveDialog, isContactParent, isRootNodeForEntity)
            .pipe(
                take(1),
            ).
            subscribe(data => {
                this._removeRelationship(data, item);
            });
    }

    // delete relationship
    // var checkedkey is to reduce the foreach operation in research screen
    private _removeRelationship(action, item) {
        // delete one relationship
        if (action.type === RelationshipTreeEvents.REMOVE_ONE_RELATIONSHIP) {
            this._relationshipService.deleteRelationship(
                this.currentClickedItemNode.relationshipId, action.payload.isDeleteReciprocalRel).
                pipe(
                    catchError(() => {
                        this._toastMessageHandler('Relationship deleted failed.', NotificationStyles.Error);
                        return of('ERROR');
                    }),
                    take(1)
                ).subscribe((response) => {
                    if (response !== 'ERROR') {
                        this._successRemoveHandler(this.rootNode, item);
                    }
                });
        }

        // delete multi relationship
        if (action.type === RelationshipTreeEvents.REMOVE_MULTI_RELATIONSHIP) {
            const deleteResponse: Array<Observable<any>> = [];
            // childForCurrentClickedParentNodes includes: children node and relationshiptype node
            const parentNodeLength = this.childForCurrentClickedParentNodes.length - 1;
            for (let i = 0; i < parentNodeLength; i++) {
                deleteResponse.push(
                    this._relationshipService.deleteRelationship(
                        this.childForCurrentClickedParentNodes[i].relationshipId, action.payload.isDeleteReciprocalRel).pipe(
                            catchError(() => {
                                this._toastMessageHandler('Relationship deleted failed.', NotificationStyles.Error);
                                return of('ERROR');
                            }),
                            take(1),
                        ),
                );
            }
            forkJoin(deleteResponse).subscribe(res => {
                res.forEach(response => {
                    if (response === 'ERROR') {
                        this._toastMessageHandler('Relationship deleted failed.', NotificationStyles.Error);
                    }
                });
                this._successRemoveHandler(this.rootNode, item);
            });
        }
    }

    // open add entity to relationship tree's dialog
    private _openAddEntityDialog(title, item) {
        // request:
        // 1. when click on relationship panel, all the context menu need to show
        // 2. when click on entity item, need to show the dialog
        // 3. when click on relationship type, this type need to show in filter panel as default
        // 4. we can choose to create reciprocal relationship and replace the origin entities below this relationship type
        // 5. support user to create the non-existing entity
        if (!item) {
            item = this.rootNode;
        }
        let currentRelationshipType: RelationshipType;
        const dialogCheckboxConfig = {
            isReplaceWithCreatedEntity: false, // replace
            isCreatWithReciprocalRel: true,  // create reciprocal
            isCreatWithReciprocalRelShow: false,  // show the create reciprocal checkbox
            isReplaceExistingShow: true // show replace checkbox
        };
        // here is the new request: if we click the rel-type, add contact and add entity need to show at the same time
        // but only valid operation will be added to dialog defaultly
        let operation = '';
        if (item.parentId && item.parentId.includes(RelationshipTreeNodeCategory.ENTITY_GROUP)) {
            operation = RelationshipTreeActions.ADD_ENTITIES;
        } else if (item.parentId && item.parentId.includes(RelationshipTreeNodeCategory.CONTACTS_GROUP)) {
            operation = RelationshipTreeActions.ADD_CONTACTS;
        }
        if (item.level === '3' && item.parentId && !item.parentId.includes(RelationshipTreeNodeCategory.TEAM_MEMBER_GROUP) &&
            !item.parentId.includes(RelationshipTreeNodeCategory.TEAMS_GROUP) && operation === title) {
            currentRelationshipType = new RelationshipType(item.uuid.slice(-32), item.name);
        } else if (item.level === '4') {
            // if click the entity/contact node, the rel-type should show in the filter dialog
            if (item.parentId && ((item.parentId.includes(RelationshipTreeNodeCategory.ENTITY_GROUP) &&
                title === RelationshipTreeActions.ADD_ENTITIES) || (item.parentId.includes(RelationshipTreeNodeCategory.CONTACTS_GROUP) &&
                    title === RelationshipTreeActions.ADD_CONTACTS))) {
                const name = this.config.data.filter(element => item.parentId === element.uuid)[0].name;
                currentRelationshipType = new RelationshipType(item.parentId.slice(-32), name);
            }
        }

        // get dialog title
        let dialogTitle = '';
        if (this.rootNode.name === this.rootNode.shortName) {
            dialogTitle = title + ' to ' + this.rootNode.name;
        } else {
            dialogTitle = title + ' to ' + this.rootNode.name + ' (' + this.rootNode.shortName + ')';
        }


        this.selectedItemValidRelationshipType = [];
        // here is to filter valid relationship for clicked entity
        this.totalValidRelationshipType.forEach(element => {
            if (title === RelationshipTreeActions.ADD_ENTITIES) {
                // when clicked item is an entity
                if (this.rootNode.type.id !== EntityType.CONTACT.id) {
                    if (element.childEntityType.id !== EntityType.CONTACT.id && element.childEntityType.id !== EntityType.TEAM.id
                        && element.childEntityType.id !== EntityType.USER.id && this.rootNode.type.id === element.parentEntityType.id) {
                        this.selectedItemValidRelationshipType.push({
                            'id': element.relationshipType.id,
                            'caption': element.relationshipType.name,
                        });
                    }
                } else {
                    if (element.childEntityType.id === EntityType.CONTACT.id &&
                        element.parentEntityType.id === EntityType.CONTACT.id) {
                        this.selectedItemValidRelationshipType.push({
                            'id': element.relationshipType.id,
                            'caption': element.relationshipType.name,
                        });
                    }
                }
            } else {
                // Add Contacts
                if (this.rootNode.type.id !== EntityType.CONTACT.id) {
                    if (element.childEntityType.id === EntityType.CONTACT.id &&
                        element.parentEntityType.id === EntityType.CONTACT.id) {
                        this.selectedItemValidRelationshipType.push({
                            'id': element.relationshipType.id,
                            'caption': element.relationshipType.name,
                        });
                    }
                } else {
                    if (element.childEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id &&
                        element.parentEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id) {
                        this.selectedItemValidRelationshipType.push({
                            'id': element.relationshipType.id,
                            'caption': element.relationshipType.name,
                        });
                    }
                }
            }
        });

        if (title === RelationshipTreeActions.ADD_CONTACTS) {
            dialogCheckboxConfig.isCreatWithReciprocalRelShow = false;
        } else {
            if (this.rootNode.type.id === EntityType.CONTACT.id) {
                dialogCheckboxConfig.isCreatWithReciprocalRelShow = false;
            } else {
                dialogCheckboxConfig.isCreatWithReciprocalRelShow = true;
            }
        }

        // to remove the same item and sort
        if (this.selectedItemValidRelationshipType.length !== 0) {
            this.selectedItemValidRelationshipType = _lodash.uniqWith(
                this.selectedItemValidRelationshipType, _lodash.isEqual);
            this.selectedItemValidRelationshipType = _lodash.sortBy(this.selectedItemValidRelationshipType, element => element.caption);
        }

        // send the data to subject and will operate
        this._addRelEntityDialogService.openAddEntityDialog(dialogTitle, title, currentRelationshipType, this.rootNode,
            this.selectedItemValidRelationshipType, this.totalValidRelationshipType, dialogCheckboxConfig)
            .pipe(
                catchError((err) => {
                    this._toastMessageHandler(err.message, NotificationStyles.Error);
                    return of(null);
                }),
                take(1)
            ).subscribe(res => {
                if (res && res.type === RelationshipTreeEvents.ADD_ENTITY) {
                    // to boradcast the action to entity screen and contact screen and research screen
                    this._relationshipTreeService.relationshipTreeOperate$.next({
                        type: RelationshipTreeActions.ADD_RELATIONSHIP,
                        payload: {
                            rootNodeId: this.rootNode.id,
                            relationshipTypes: res.payload.relationshipTypes,
                        }
                    });

                    // to toast message for success and error status
                    if (res.payload.serverResponse === 'error') {
                        if (title === RelationshipTreeActions.ADD_ENTITIES) {
                            this._toastMessageHandler('Adding entity(s) failed, please try again.', NotificationStyles.Error);
                        } else {
                            this._toastMessageHandler('Adding contact(s) failed, please try again.', NotificationStyles.Error);
                        }
                    } else {
                        if (title === RelationshipTreeActions.ADD_ENTITIES) {
                            this._toastMessageHandler('All entities are successfully added.', NotificationStyles.Success);
                        } else {
                            this._toastMessageHandler('All contacts are successfully added.', NotificationStyles.Success);
                        }
                    }
                }
            });
    }

    private _setRelationshipStyleByData() {
        if (this.relationshipItems.length === 0) {
            this.noDataStyle = 'flex';
        } else {
            this.noDataStyle = 'none';
        }
    }

    private _toastMessageHandler(message, toastStyle: NotificationStyles) {
        this._toast.notify({
            message: message,
            style: toastStyle
        });
        // this.isRelationshipDataPrepared = true;
    }

    private _successRemoveHandler(rootNode, item) {
        // in order to improve performance, no need to reload all relationship
        this._relationshipTreeService.relationshipTreeOperate$.next({
            type: RelationshipTreeActions.REMOVE_RELATIONSHIP,
            payload: {
                rootNodeId: rootNode.id,
                removeItem: item
            }
        });
        this._toastMessageHandler('Relationship successfully deleted.', NotificationStyles.Success);
    }

    private _triggerShowAsChange(showAs) {
        if (showAs === 'name') {
            this.showAsShortNameChecked = false;
            this.showAsNameChecked = true;
        } else {
            this.showAsShortNameChecked = true;
            this.showAsNameChecked = false;
        }
        this._contactDetailService.action$.next({
            type: ContactComponentActionTypes.CHANGE_RELATIONSHIP_SHOW_AS,
            payload: {
                origin: ContactComponentCategory.ContactRelationships,
                originPosition: this.config.position,
                seletedTab: this.selectedIndex,
                showAs: showAs,
            }
        });
        this._initData(this.config.data);
        this._changeDetectorRef.detectChanges();
    }

    private _openRemoveParentRelationshipDialog(item) {
        // 1: get rootNode information
        let isRootNodeForEntity = true;
        if (this.rootNode.type.id === EntityType.CONTACT.id) {
            isRootNodeForEntity = false;
        }

        // 2: get relationship type information
        const allNodesLength = this.config.data.length;
        const newArr = [];
        for (let i = 0; i < allNodesLength; i++) {
            if (item.uuid === this.config.data[i].parentId) {
                newArr.push(this.config.data[i]);
            }
        }
        this.childForCurrentClickedParentNodes = newArr;
        newArr.push(item);

        // 3: get the var: isContactParent
        let isContactParent = false;
        if (item.parentId.indexOf(RelationshipTreeNodeCategory.CONTACTS_GROUP) > -1) {
            isContactParent = true;
        }

        // 4: send the data to subject
        this._removeRelationshipDialogService.open(
            this.rootNode, this.rootNode.shortName, item.name, null, isContactParent, isRootNodeForEntity).pipe(
                take(1),
            ).subscribe(data => {
                this._removeRelationship(data, item);
            });
    }

    // will go on finish this refresh function
    private _actionMessageHandler(action) {
        if (action.type === ContactComponentActionTypes.RELOAD_RELATIONSHIP) {
            this.config.data = action.payload;
            this._initData(action.payload);
        }
    }

    private _initData(relationshipItems: Array<any>) {
        this.rootNode = this.config.data.find(node => node.level === '1');
        this.relationshipItems = [];
        relationshipItems.filter(item => item.level === '4' || (item.level === '3' && item.type && item.type.id === EntityType.TEAM.id))
            .forEach(element => {
                // get the duplicate index of the same relationship type
                const index = this.relationshipItems.findIndex(item =>
                    item.title && item.title.value === element.relationshipTypeName && item.value[0]
                    && item.value[0].nodeDetail.parentId === element.parentId);
                if (index > -1) {
                    this.relationshipItems[index].value.push({
                        value: (this.showAsNameChecked && !this.showAsShortNameChecked) ? element.name : element.shortName,
                        valueId: element.id,
                        clickable: true,
                        nodeDetail: element,
                    });
                } else {
                    this.relationshipItems.push({
                        title: {
                            clickable: element.level === '3' ? false : true,
                            value: element.relationshipTypeName,
                            nodeDetail: {
                                company: '',
                                id: element.parentId,
                                level: '3',
                                parentId: element.parentId,
                                nodeType: 'relationshipType',
                                uuid: element.parentId,
                                name: element.relationshipTypeName,
                            },
                        },
                        value: [{
                            value: (this.showAsNameChecked && !this.showAsShortNameChecked) ? element.name : element.shortName,
                            valueId: element.id,
                            clickable: true,
                            nodeDetail: element,
                            relationshipId: element.relationshipId,
                        }]
                    });
                }
            });

        this.defaultRelationshipItems = this.relationshipItems;
        this._setRelationshipStyleByData();
        this.selectChange(this.config.selectedTab);
        this._changeDetectorRef.detectChanges();
    }

    // init the context menu data
    private _initContextMenu() {
        this.contextMenu = [
            { id: ContactBasicInformationCategory.BasicInformation, title: ContactBasicInformationCategory.BasicInformation },
            { id: ContactBasicInformationCategory.ContactInformation, title: ContactBasicInformationCategory.ContactInformation },
            { id: ContactBasicInformationCategory.Employment, title: ContactBasicInformationCategory.Employment },
            { id: ContactBasicInformationCategory.Address, title: ContactBasicInformationCategory.Address },
            { id: ContactBasicInformationCategory.Internet, title: ContactBasicInformationCategory.Internet },
            { id: ContactBasicInformationCategory.Other, title: ContactBasicInformationCategory.Other },
            { id: ContactBasicInformationCategory.Note, title: ContactBasicInformationCategory.Note },
        ];
    }

    private _updateChangesToUI() {
        if (!this._changeDetectorRef[businessConstants.common.changeDetectorDestroyedIdentifier]) {
            this._changeDetectorRef.detectChanges();
        }
    }
}
